<template>
  <div class="right cadfm-flexitem-stretched">

    <action-panel>
      <action-bar >
        <b-navbar-nav class="ml-auto">
          <action-button  @click="toggleRightPanel"  icon="hide" bold text="Hide" title="Hide panel" :disabled="false"/>

        </b-navbar-nav>

      </action-bar>

      <action-content>

        <Content  :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

 </div>
</template>

<script>
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'


import Content from "@/components/LibraryManager/Views/LibraryTable/Right/Content/Content"

export default {
  name: 'Right',
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {

    }
  },
  computed: {

  },

  methods: {
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    }

  }
}
</script>


<style scoped>
  .right{
    max-width: 450px;


  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryTable/Right/Right.vue